import { updateScheduledOrderConstants } from '../constants';

const updateScheduledOrder = (state, action) => {
    if (state === undefined) {
        return {
            data: {},
            loading: true,
            error: false,
            success: false,
        };
    }

    switch (action.type) {
        case updateScheduledOrderConstants.UPDATE_SCHEDULED_ORDER_REQUEST:
            return {
                data: {},
                loading: true,
                error: false,
                success: false,
            };

        case updateScheduledOrderConstants.UPDATE_SCHEDULED_ORDER_SUCCESS:
            return {
                data: action.payload,
                loading: false,
                error: false,
                success: true,
            };

        case updateScheduledOrderConstants.UPDATE_SCHEDULED_ORDER_FAILURE:
            return {
                data: {},
                loading: false,
                error: true,
                success: false,
            };

        default:
            return state;
    }
};

export default updateScheduledOrder;
